import { Fade, Hidden, IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'

import { getTranslate } from '../../localization'
import { AddOnPolicy } from '../../types/cancelAndModifyPolicies'
import PolicyRowSkeleton from '../CancelPoliciesList/PolicyRow.skeleton'
import PolicyRowMobileSkeleton from '../CancelPoliciesList/PolicyRowMobile.skeleton'
import useCancelStyles from '../CancelPoliciesList/styles/PoliciesTable.styles'
import AddOnPolicyRow from './AddOnPolicyRow'
import AddOnPolicyRowMobile from './AddOnPolicyRowMobile'
import useStyles from './styles/AddOnPoliciesTable.styles'

interface AddOnPoliciesTableProps {
  data: AddOnPolicy[]
  loading: boolean
  providerCode: string
  canEdit: boolean
  canDelete: boolean
  refetch: () => void
}

const SKELETON_ROWS = Array(5).fill('')

export const AddOnPoliciesTable: React.FC<AddOnPoliciesTableProps> = ({
  data,
  loading,
  providerCode,
  canEdit,
  canDelete,
  refetch
}) => {
  const cancelClasses = useCancelStyles()
  const classes = useStyles()
  const rowProps = { providerCode, canEdit, canDelete }

  return (
    <>
      <Hidden smDown>
        <div className={cancelClasses.root}>
          <div className={classes.tableHead}>
            <Typography variant="body1">{getTranslate('Name')}</Typography>
            <Typography variant="body1">{getTranslate('Cut-off')}</Typography>
            <Typography variant="body1">
              {getTranslate('Description')}
            </Typography>
            <div className={cancelClasses.refreshButtonContainer}>
              <IconButton
                aria-label={getTranslate('Refresh')}
                onClick={() => refetch()}>
                <RefreshIcon fontSize="small" />
              </IconButton>
            </div>
          </div>
          {loading
            ? SKELETON_ROWS.map((_, index) => (
                <PolicyRowSkeleton key={`add-on-policy-skeleton-${index}`} />
              ))
            : data.map((policy) => (
                <Fade in timeout={600} key={policy.basicDetails.id}>
                  <div>
                    <AddOnPolicyRow data={policy} {...rowProps} />
                  </div>
                </Fade>
              ))}
        </div>
      </Hidden>
      <Hidden mdUp>
        <div className={cancelClasses.root}>
          <div className={cancelClasses.tableHeadMobile}>
            <div className={cancelClasses.tableHeadCellMobile}>
              <Typography variant="body1">{getTranslate('Name')}</Typography>
            </div>
            <div />
          </div>
          {loading
            ? SKELETON_ROWS.map((_, index) => (
                <PolicyRowMobileSkeleton
                  key={`add-on-policy-mobile-skeleton-${index}`}
                />
              ))
            : data.map((policy) => (
                <Fade in timeout={600} key={policy.basicDetails.id}>
                  <div>
                    <AddOnPolicyRowMobile data={policy} {...rowProps} />
                  </div>
                </Fade>
              ))}
        </div>
      </Hidden>
    </>
  )
}
